import React from 'react';
import { X } from 'lucide-react';
interface WelcomeVideoModalProps {
  onClose: () => void;
}
export const WelcomeVideoModal: React.FC<WelcomeVideoModalProps> = ({
  onClose
}) => {
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-22998">
      <div className="relative w-full max-w-md animate-in zoom-in-90 duration-300 bg-white dark:bg-gray-900 rounded-lg shadow-lg overflow-hidden" data-id="element-22999">
        <button className="absolute right-2 top-2 z-10 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors" onClick={onClose} data-id="element-23000">
          <X size={20} data-id="element-23001" />
        </button>
        <div className="p-6" data-id="element-23002">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-23003">
            Welcome to the Platform!
          </h2>
          <p className="text-gray-700 dark:text-gray-300 mb-4" data-id="element-23004">
            We're excited to have you join our community. Explore all the
            features and connect with your favorite angels.
          </p>
          <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all duration-300" onClick={onClose} data-id="element-23005">
            Get Started
          </button>
        </div>
      </div>
    </div>;
};